import React, { useEffect, useState } from 'react';

import { LineNumbers } from '../../../../components/play/Types/Types';
import { isNonEmptyLine, isValidLine, PRIMARY_NUMBERS } from '../../../../components/play/helpers/linesHelper';
import useLinesHelper from '../../../../components/play/helpers/useLinesHelper';

// TODO: add translations
export default function Lines() {
    const { lines, lottery, numbersPerLine } = useLinesHelper();
    const [filteredLines, setFilteredLines] = useState<LineNumbers[]>(lines);

    useEffect(() => {
        setFilteredLines(lines.filter(isNonEmptyLine).filter((line) => isValidLine(lottery, line, numbersPerLine)));
    }, [lines]);

    return (
        <>
            <div>
                Lines selected: <span className="fw-bold">{filteredLines.length}</span>
            </div>

            {filteredLines.map((line, lineIndex) =>
                line.map((numbers, rangeIndex) => {
                    return (
                        <div className="lotto-grid mt-3" key={`${lineIndex}${rangeIndex}`}>
                            {numbers.map((number) => (
                                <div
                                    className={rangeIndex === PRIMARY_NUMBERS ? 'lotto-ball bg-info' : 'lotto-star'}
                                    key={number}
                                >
                                    {number}
                                </div>
                            ))}
                        </div>
                    );
                })
            )}
        </>
    );
}
